import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LeftTree from './left-tree.vue';
export default {
  name: 'AreaSelectDialog',
  components: {
    LeftTree: LeftTree
  },
  props: {
    orgDialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    multiple: {
      // 默认单选
      type: Boolean,
      default: false
    },
    canBeNullSelect: {
      // 是否允许机构选择为空
      type: Boolean,
      default: false
    },
    cityIds: {
      // 回显: 单选时数组大小为1才有效,如["100314"],传入重复的机构编号会被去重,传入无效的机构编号会被忽略
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rootOrgId: {
      // 根机构限定
      type: String,
      default: ''
    },
    modal: {
      // 是否需要遮罩
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      // 遮罩层是否插入至 body 元素上
      type: Boolean,
      default: true
    },
    appendToBody: {
      // Dialog 自身是否插入至 body 元素上
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    lockScroll: {
      // 是否在 Dialog 出现时将 body 滚动锁定
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      pickedNode: [],
      searchLoading: false,
      options: [],
      orgName: '',
      orgId: ''
    };
  },
  created: function created() {
    var _this = this;
    if (!this.cityIds || !(this.cityIds instanceof Array) || this.cityIds.length === 0) {
      // 回显校验
    } else {
      var cityArr = Array.from(new Set(this.cityIds).values());
      if (!this.multiple && cityArr.length !== 1) {
        // 单选回显校验
        return;
      }
      this.$API.getRequest({
        url: '/punish/administrativePunish/lawEnforcementRegion'
      }).then(function (res) {
        // eslint-disable-next-line array-callback-return
        res.result.filter(function (item) {
          if (cityArr.indexOf(item.id) > -1) {
            _this.pickedNode.push(item);
          }
          if (item.city) {
            // eslint-disable-next-line array-callback-return
            item.city.filter(function (val) {
              if (cityArr.indexOf(val.id) > -1) {
                _this.pickedNode.push(val);
              }
            });
          }
        });
      });
    }
  },
  methods: {
    handleNodePick: function handleNodePick(node) {
      if (!this.multiple) {
        // 单选
        this.pickedNode = [node];
      } else if (this.pickedNode.findIndex(function (item) {
        return item.id === node.id;
      }) === -1) {
        // 多选不重复
        this.pickedNode.push(node);
      }
    },
    cleanAll: function cleanAll() {
      this.pickedNode = [];
    },
    cleanNode: function cleanNode(node) {
      this.pickedNode.splice(this.pickedNode.indexOf(node), 1);
    },
    queryOrg: function queryOrg() {
      this.$refs.tree.getRootTree(this.orgId, this.rootOrgId);
    },
    remoteMethod: function remoteMethod(query) {
      if (query !== '') {/* empty */} else {
        this.options = [];
      }
    },
    onChangeSelect: function onChangeSelect(event) {
      this.orgId = event;
    },
    confirm: function confirm() {
      if (this.canBeNullSelect) {
        this.$emit('confirm', this.pickedNode);
        return;
      }
      if (this.pickedNode.length === 0) {
        this.$message.error('请至少选择一个地区');
        return;
      }
      this.$emit('confirm', this.pickedNode);
    },
    handleClose: function handleClose() {
      this.$emit('cancle');
    }
  }
};